var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1236_1967)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 11.75,
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82336 12.6881C7.63513 12.5078 7.54102 12.2765 7.54102 11.9943C7.54102 11.6964 7.63317 11.4553 7.81748 11.2711C8.0018 11.0869 8.24689 10.9948 8.55277 10.9948H12.0116V7.53765C12.0116 7.23975 12.1018 6.99673 12.2822 6.80859C12.4626 6.62044 12.6939 6.52637 12.9763 6.52637C13.2743 6.52637 13.5155 6.61848 13.6998 6.8027C13.8842 6.98693 13.9763 7.23191 13.9763 7.53765V10.9948H17.4468C17.7449 10.9948 17.9861 11.0869 18.1704 11.2711C18.3547 11.4553 18.4469 11.6964 18.4469 11.9943C18.4469 12.2765 18.3547 12.5078 18.1704 12.6881C17.9861 12.8684 17.7449 12.9585 17.4468 12.9585H13.9763V16.4274C13.9763 16.7253 13.8842 16.9664 13.6998 17.1506C13.5155 17.3349 13.2743 17.427 12.9763 17.427C12.6939 17.427 12.4626 17.3349 12.2822 17.1506C12.1018 16.9664 12.0116 16.7253 12.0116 16.4274V12.9585H8.55277C8.25474 12.9585 8.0116 12.8684 7.82336 12.6881Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1236_1967",
    x: 0.25,
    y: 0,
    width: 25.5,
    height: 25.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1236_1967"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1236_1967",
    result: "effect2_dropShadow_1236_1967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1236_1967",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingAdd);
export default __webpack_public_path__ + "static/media/setting-add.e8e154aa8c8ca29d0eefa195ba340029.svg";
export { ForwardRef as ReactComponent };